// extracted by mini-css-extract-plugin
module.exports = {"error":"Input_error__3FZjh","label":"Input_label__j7jgv"};